import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.pagination || initialState;

export const selectPaginationLimit = createSelector(
  [selectSlice],
  state => state.limit,
);
export const selectPaginationSkip = createSelector(
  [selectSlice],
  state => state.skip,
);
export const selectPaginationPage = createSelector(
  [selectSlice],
  state => state.page,
);
export const selectPaginationTotalPages = createSelector(
  [selectSlice],
  state => state.totalPages,
);
export const selectPaginationTotalItemsCount = createSelector(
  [selectSlice],
  state => state.totalItemsCount,
);
